"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _layoutGridUtils = require("../../LayoutGrid/_layoutGridUtils");

var ANONYMOUS = '<<anonymous>>';
/* eslint-disable no-console */

var elementOrArrayOfElements = function elementOrArrayOfElements() {
  // Element is not defined unless the Browser API is defined
  if (typeof Element === 'undefined') {
    return _propTypes.default.any;
  }

  return _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.instanceOf(Element)), _propTypes.default.instanceOf(Element)]);
};

var validColumnProp = function validColumnProp(props, propName, componentName) {
  var _context2;

  var spanValue = props === null || props === void 0 ? void 0 : props[propName];
  if (!spanValue) return;

  switch ((0, _typeof2.default)(spanValue)) {
    case 'number':
      if (!(0, _layoutGridUtils.validSpan)(spanValue)) {
        var _context;

        return new Error((0, _concat.default)(_context = "Invalid property ".concat(propName, " supplied to ")).call(_context, componentName, ". Value should be a number between 1-12 (including)."));
      }

      break;

    case 'object':
      (0, _forEach.default)(_context2 = (0, _keys.default)(_constants.SCREEN_SIZE_MAP)).call(_context2, function (size) {
        var spanForSize = spanValue === null || spanValue === void 0 ? void 0 : spanValue[size];

        if (!(0, _layoutGridUtils.validSpan)(spanForSize)) {
          var _context3, _context4;

          return new Error((0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "Invalid property ".concat(propName, ".")).call(_context4, size, " supplied to ")).call(_context3, componentName, ". Value should be a number between 1-12 (including)."));
        }
      });
      break;

    default:
      break;
  }
};

var wrapValidator = function wrapValidator(validator, typeName) {
  var _context5;

  var typeChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  // eslint-disable-next-line compat/compat
  return (0, _assign.default)((0, _bind.default)(validator).call(validator), {
    typeName: typeName,
    typeChecker: typeChecker,
    // eslint-disable-next-line compat/compat
    isRequired: (0, _assign.default)((0, _bind.default)(_context5 = validator.isRequired).call(_context5), {
      typeName: typeName,
      typeChecker: typeChecker,
      typeRequired: true
    })
  });
};

var createChainableTypeChecker = function createChainableTypeChecker(validate) {
  var checkType = function checkType(isRequired, props, propName, componentName, location, propFullName) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    var value = props[propName];

    if (typeof value === 'undefined' || value === null) {
      if (isRequired) {
        var _context6, _context7, _context8;

        return new TypeError((0, _concat.default)(_context6 = (0, _concat.default)(_context7 = (0, _concat.default)(_context8 = "The ".concat(location, " `")).call(_context8, propFullName, "` is marked as required in `")).call(_context7, componentName, "`, but its value is `")).call(_context6, value === null ? 'null' : (0, _typeof2.default)(value), "`."));
      }

      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  };

  var chainedCheckType = (0, _bind.default)(checkType).call(checkType, null, false);
  chainedCheckType.isRequired = (0, _bind.default)(checkType).call(checkType, null, true);
  return chainedCheckType;
};

var range = function range(min, max) {
  if (isNaN(min)) {
    console.error('The \`min\` parameter supplied to the \`range\` propType is required and must be a \`number\`.');
    return function () {
      return null;
    };
  }

  if (isNaN(max)) {
    console.error('The \`max\` parameter supplied to the \`range\` propType is required and must be a \`number\`.');
    return function () {
      return null;
    };
  }

  if (min >= max) {
    console.error('In the \`range\` propType, the \`min\` value must be less than the \`max\` value.');
    return function () {
      return null;
    };
  }

  var validate = function validate(props, propName, componentName, location, propFullName) {
    var value = props[propName]; // If no value is provided, don't fail validation.

    if (typeof value === 'undefined' || value === null) {
      return null;
    }

    if (isNaN(value)) {
      var _context9, _context10, _context11;

      return new TypeError((0, _concat.default)(_context9 = (0, _concat.default)(_context10 = (0, _concat.default)(_context11 = "Invalid ".concat(location, " `")).call(_context11, propFullName, "` of type `")).call(_context10, (0, _typeof2.default)(value), "` supplied to `")).call(_context9, componentName, "`, expected `number`."));
    }

    if (value < min || value > max) {
      var _context12, _context13, _context14, _context15, _context16;

      return new Error((0, _concat.default)(_context12 = (0, _concat.default)(_context13 = (0, _concat.default)(_context14 = (0, _concat.default)(_context15 = (0, _concat.default)(_context16 = "The ".concat(location, " `")).call(_context16, propFullName, "` supplied to `")).call(_context15, componentName, "` has a value of `")).call(_context14, value, "`, which is not in the range `")).call(_context13, min, "` to `")).call(_context12, max, "` (inclusive)."));
    }

    return null;
  };

  return wrapValidator(createChainableTypeChecker(validate), 'range', {
    min: min,
    max: max
  });
};

var i18n = function i18n(obj) {
  if (!obj) {
    console.error('The shape parameter supplied to the \`i18n\` propType is required.');
    return function () {
      return null;
    };
  }

  var shapeKeys = (0, _keys.default)(obj);

  var validate = function validate(props, propName, componentName, location, propFullName) {
    var value = props[propName];

    if (!value) {
      var _context17, _context18;

      return new Error((0, _concat.default)(_context17 = (0, _concat.default)(_context18 = "The ".concat(location, " `")).call(_context18, propFullName, "` was not supplied to `")).call(_context17, componentName, "`."));
    }

    var valueKeys = (0, _keys.default)(value);

    if (valueKeys.length !== shapeKeys.length) {
      var _context19, _context20, _context21, _context22, _context23, _context24;

      var missMatchType = '';
      var missMatchKeys = [];

      if (valueKeys.length < shapeKeys.length) {
        missMatchType = 'Missing';
        missMatchKeys = (0, _filter.default)(shapeKeys).call(shapeKeys, function (key) {
          return !(0, _some.default)(valueKeys).call(valueKeys, function (k) {
            return key === k;
          });
        });
      } else {
        missMatchType = 'Extra';
        missMatchKeys = (0, _filter.default)(valueKeys).call(valueKeys, function (key) {
          return !(0, _some.default)(shapeKeys).call(shapeKeys, function (k) {
            return key === k;
          });
        });
      }

      return new Error((0, _concat.default)(_context19 = (0, _concat.default)(_context20 = (0, _concat.default)(_context21 = (0, _concat.default)(_context22 = (0, _concat.default)(_context23 = (0, _concat.default)(_context24 = "The ".concat(location, " `")).call(_context24, propFullName, "` supplied to `")).call(_context23, componentName, "` has ")).call(_context22, valueKeys.length, " string(s) when ")).call(_context21, shapeKeys.length, " were expected. ")).call(_context20, missMatchType, " ")).call(_context19, (0, _map.default)(missMatchKeys).call(missMatchKeys, function (key) {
        return "`".concat(key, "`");
      }).join(', '), "."));
    }

    return null;
  };

  return wrapValidator(createChainableTypeChecker(validate), 'i18n', obj);
};

var _default = {
  elementOrArrayOfElements: elementOrArrayOfElements,
  range: range,
  i18n: i18n,
  validColumnProp: validColumnProp
};
exports.default = _default;